// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CommonMenu_wrapper_1PkM0"};